(function() {

    
    document.querySelectorAll('.shared-popup-callme-modal-wrapper .popup-callme-title-action-close').forEach(actionClose => {
        actionClose.addEventListener('click', (e) => {
            e.preventDefault();
            actionClose.closest('.popup-callme-block').classList.add('hidden');
            return false;
        });
    });


    document.querySelectorAll('.open-popup-callme').forEach(actionButton => {        
        actionButton.addEventListener('click', (e) => {            
            e.preventDefault();
            const modalId = actionButton.getAttribute('data-modal');
            
            const referencieId = actionButton.getAttribute('data-reference');
            if ( referencieId && referencieId != '' ) {
                document.getElementById(modalId).querySelector('input[name=reference]').value = referencieId;
            }

            document.getElementById(modalId).querySelector('.popup-callme-block').classList.remove('hidden');
            
            return false;
        });
    });


})();